import { FormRule } from "antd";

function measureHtmlHeight(html: string): number {
  // Create a temporary div to measure the content
  const div = document.createElement("div");

  div.style.position = "absolute";
  div.style.visibility = "hidden";
  div.style.width = "200px"; // Set a fixed width to ensure consistent measurement
  div.innerHTML = html;
  document.body.appendChild(div);

  const height = div.offsetHeight;

  document.body.removeChild(div);

  return height;
}

export function validateHtmlHeight(maxHeight: number): FormRule {
  return {
    validator: async (_, value: string) => {
      if (!value) return Promise.resolve();

      const height = measureHtmlHeight(value);

      console.log({ height, value });

      if (height > maxHeight) {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
          message: `Estimated content height (${height}px) exceeds maximum allowed height of ${maxHeight}px (Around ${Math.floor(
            maxHeight / 24
          )} lines of normal text)`,
        });
      }

      return Promise.resolve();
    },
  };
}
